package com.fireavert.menu.client.presentation

import com.fireavert.dashboard.client.presentation.DashboardController
import com.fireavert.fire_risk.client.presentation.RiskTableController
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageSectionController
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

class GlobalFilterController(
    private val dashboardController: DashboardController,
    private val reportsController: ReportsPageSectionController,
    private val fireRiskController: RiskTableController,
) {
    // In GlobalFilterController
    suspend fun loadDashboardData(
        startDate: LocalDate,
        endDate: LocalDate,
        propertyId: Int?,
    ) {
        dashboardController.updateData(startDate, endDate, propertyId)
    }

    suspend fun loadReportsData(propertyId: Int?) {
        val currentYear = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).year
        val updatedPropertyId: Int = if (propertyId == 0) {
            -1
        } else {
            propertyId ?: -1
        }
        reportsController.onLoad(updatedPropertyId, "Smoke Events", currentYear)
    }

    suspend fun loadFireRiskData() {
        fireRiskController.onLoad()
    }
}